import {
  DEFAULT_GENERATION_MODEL_KEY,
  GENERATION_MODEL_CATALOG,
  GENERATION_MODEL_KEYS,
  type GenerationModelKey,
  type SafeGenerationModelMetadata,
} from '@malaberg/shared';

export type RuntimeGenerationModelOption = SafeGenerationModelMetadata & {
  available: boolean;
};

export type RuntimeGenerationModelInfo = {
  generationModels?: RuntimeGenerationModelOption[] | null;
} | null;

export function generationModelOptions(
  runtimeInfo?: RuntimeGenerationModelInfo
): RuntimeGenerationModelOption[] {
  return GENERATION_MODEL_KEYS.map((key) => {
    const runtimeOption = runtimeInfo?.generationModels?.find((option) => option.key === key);
    if (runtimeOption) return runtimeOption;

    return {
      ...GENERATION_MODEL_CATALOG[key],
      available: key === DEFAULT_GENERATION_MODEL_KEY,
    };
  });
}

export function generationModelLabel(key?: GenerationModelKey | null): string {
  return GENERATION_MODEL_CATALOG[key ?? DEFAULT_GENERATION_MODEL_KEY].label;
}

export function generationModelShortLabel(label: string): string {
  if (label === 'Claude Opus 4.8 Extra') return 'Opus 4.8';
  if (label === 'Claude Opus 4.6 Max') return 'Opus 4.6';
  return label;
}

export function runtimeInfoModelLabel(runtimeInfo?: RuntimeGenerationModelInfo): string {
  const available = generationModelOptions(runtimeInfo).filter((option) => option.available);
  const labels = available.length > 0 ? available : generationModelOptions(null);

  return labels.map((option) => generationModelShortLabel(option.label)).join(', ');
}

export function generationModelUnavailableMessage(
  key: GenerationModelKey | undefined,
  runtimeInfo?: RuntimeGenerationModelInfo
): string | null {
  const selectedKey = key ?? DEFAULT_GENERATION_MODEL_KEY;
  if (selectedKey === DEFAULT_GENERATION_MODEL_KEY) return null;

  if (!runtimeInfo?.generationModels) {
    return `${generationModelLabel(selectedKey)} availability is still loading.`;
  }

  const runtimeOption = runtimeInfo?.generationModels?.find((option) => option.key === selectedKey);

  if (runtimeOption?.available) return null;

  return `${runtimeOption?.label ?? generationModelLabel(selectedKey)} is not configured.`;
}
